module.exports = __webpack_public_path__ + "static/media/get-involved--donate.7412d386.jpg";